var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.334 0.750214H5.665C2.644 0.750214 0.75 2.88921 0.75 5.91621V14.0842C0.75 17.1112 2.635 19.2502 5.665 19.2502H14.333C17.364 19.2502 19.25 17.1112 19.25 14.0842V5.91621C19.25 2.88921 17.364 0.750214 14.334 0.750214Z",
    fill: "#6C5DD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1363 9.99103C14.1363 10.4052 13.8005 10.741 13.3863 10.741H6.60937C6.19516 10.741 5.85938 10.4052 5.85937 9.99103C5.85937 9.57681 6.19516 9.24103 6.60937 9.24103H13.3863C13.8005 9.24103 14.1363 9.57681 14.1363 9.99103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveActive);
export default __webpack_public_path__ + "static/media/remove-active.9e4939191314a88e3e63ea42a8c91c13.svg";
export { ForwardRef as ReactComponent };